/**
 * SUN-226 — whose dealer holds a lead. Pure labels for the lead header chip,
 * the dealer picker rows and the "given to dealer" history line.
 * Company-owned dealer (no manager) → null → no chip. <Mgr> = manager's first name.
 */
export interface DealerManagerRef { id: string; firstName: string }

/** Lead header chip. Lead owned by the dealer's manager → "<Mgr>'s lead · <Mgr>'s dealer". */
export function dealerOwnershipChip(i: {
  ownerUserId: string | null | undefined;
  dealerManager: DealerManagerRef | null | undefined;
}): string | null {
  const m = i.dealerManager;
  const name = m?.firstName?.trim();
  if (!m || !name) return null;
  if (i.ownerUserId && i.ownerUserId === m.id) return `${name}'s lead · ${name}'s dealer`;
  return `${name}'s dealer`;
}

/** Picker row chip: "<Mgr>'s dealer", or null for a company-owned dealer. */
export function dealerRowChip(managerFirstName: string | null | undefined): string | null {
  const name = managerFirstName?.trim();
  return name ? `${name}'s dealer` : null;
}

/**
 * History line for a `dealer_assigned` stage event. With an on-behalf record:
 * "Given to dealer <Dealer> by <By> on behalf of <Mgr>"; otherwise "Given to dealer <Dealer>".
 */
export function dealerAssignedLine(payload: unknown): string {
  const p = (payload && typeof payload === 'object' ? payload : {}) as Record<string, unknown>;
  const dealer = typeof p.dealerName === 'string' && p.dealerName.trim() ? p.dealerName.trim() : 'a dealer';
  const by = typeof p.byUserName === 'string' ? p.byUserName.trim() : '';
  const mgr = typeof p.onBehalfOfName === 'string' ? p.onBehalfOfName.trim() : '';
  if (mgr && by) return `Given to dealer ${dealer} by ${by} on behalf of ${mgr}`;
  return `Given to dealer ${dealer}`;
}
